// extracted by mini-css-extract-plugin
export default {"widgetCardsWrapper":"ProjectSummary_widgetCardsWrapper__12zMZ"};